/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useNavigate,Link } from 'react-router-dom';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";
import CompanyInfo from "../../components/includes/CompanyInfo";
import Footer from "../../components/includes/Footer";
import {LoginAfterCheckLogin} from "../../components/common/Common";

import "../../css/style.css";

import userIcon from "../../img/icon/icon-stroke-profile.svg";
import messageIcon from "../../img/icon/icon-stroke-megaphone.svg";
import settingIcon from "../../img/icon/icon-stroke-setting.svg";
import documentIcon from "../../img/icon/icon-stroke-document.svg";
import justiceIcon from "../../img/icon/icon-stroke-justice.svg";

const MyPage = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검

  const navigate = useNavigate();

  const onLogoutHandler = (e) => {
    if(!window.confirm('로그아웃하시겠습니까?')) return false;

    localStorage.removeItem("mem_idx");
    localStorage.removeItem("mem_id");
    localStorage.removeItem("mem_name");
    localStorage.removeItem("mem_mobile");
    localStorage.removeItem("mem_mode");
    localStorage.removeItem("mem_type");
    localStorage.removeItem("mem_company");
    localStorage.removeItem("autoLogin");
    localStorage.removeItem("userLoginState");

    localStorage.removeItem("setHistoryDate");
    navigate('/Login');
  }

  return(
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'마이페이지'} varBackString="none"/>
        <div className="mypage-content-wrap">
          <div className="mypage-menu mb50">
            <ul>
              <li><Link to="/MyInfo" className="link"><span className="icon"><img src={userIcon} alt="" /></span><span className="text">개인 정보 수정</span></Link></li>
              <li><Link to="/Notice" className="link"><span className="icon"><img src={messageIcon} alt="" /></span><span className="text">공지사항</span></Link></li>
              <li><Link to="/Question" className="link"><span className="icon"><img src={messageIcon} alt="" /></span><span className="text">1:1문의</span></Link></li>
              <li><Link to="/AppSetting" className="link"><span className="icon"><img src={settingIcon} alt="" /></span><span className="text">앱 설정</span></Link></li>
              <li><Link to="/Conditions/1" className="link"><span className="icon"><img src={documentIcon} alt="" /></span><span className="text">이용약관</span></Link> </li>
              <li><Link to="/Conditions/2" className="link"><span className="icon"><img src={justiceIcon} alt="" /></span><span className="text">개인정보 처리방침</span></Link> </li>
            </ul>
          </div>
          <div style={{width:"100%",display:"flex",justifyContent:"right"}}>
            <button className="btn-large btn-white mb30 logout" onClick={onLogoutHandler}>로그아웃</button>
          </div>
        </div>
      </div>
      <CompanyInfo />
      <Footer varActiveMode={3}/>
    </div>
  );
}
export default MyPage;